/**
 * Plain string mirrors of the CLEAR_* / RESET_* action-type constants for feature
 * domains that are loaded lazily via injectReducerGroup() (catalog, marketing,
 * reports, stock, orders, finance, design, posPrint, customers, etc).
 *
 * GlobalActions.clearAllData()/clearLoading() dispatch these types on every
 * restaurant switch/logout. Importing them from each domain's XActions.js file
 * instead of from here would pull that file's entire module graph - including its
 * slice of the ~700-function src/config/config.js API client - into the eager
 * bundle, since GlobalActions.js is referenced by the always-loaded core reducer
 * set (see src/redux/reducers/coreReducers.js) even though the actions themselves
 * are only otherwise used behind a lazy route.
 *
 * Keep these values in sync with the canonical `export const CLEAR_*` declarations
 * in each domain's actions file - they are plain redux action-type strings not
 * expected to change.
 */

// BranchesFinanceActions
export const CLEAR_ALL_BRANCHES_FINANCE = 'CLEAR_ALL_BRANCHES_FINANCE'
export const CLEAR_BRANCHES_FINANCE_LOADING = 'CLEAR_BRANCHES_FINANCE_LOADING'

// CategoryActions
export const CLEAR_ALL_CATEGORY = 'CLEAR_CATEGORY_ALL'
export const CLEAR_CATEGORY_LOADING = 'CLEAR_CATEGORY_LOADING'

// DiscountActions
export const CLEAR_ALL_DISCOUNT = 'CLEAR_ALL_DISCOUNT'
export const CLEAR_DISCOUNT_LOADING = 'CLEAR_DISCOUNT_LOADING'

// EventsActons
export const CLEAR_ALL_EVENTS = 'CLEAR_ALL_EVENTS'
export const CLEAR_EVENTS_LOADING = 'CLEAR_EVENTS_LOADING'

// FeedbackActions
export const CLEAR_ALL_FEEDBACKS = 'CLEAR_ALL_FEEDBACKS'
export const CLEAR_FEEDBACK_LOADING = 'CLEAR_FEEDBACK_LOADING'

// GalleryActions
export const CLEAR_ALL_GALLERY = 'CLEAR_ALL_GALLERY'
export const CLEAR_GALLERY_LOADING = 'CLEAR_GALLERY_LOADING'

// GroupActions
export const CLEAR_ALL_GROUP = 'CLEAR_ALL_GROUP'
export const CLEAR_GROUP_LOADING = 'CLEAR_GROUP_LOADING'

// IngredientActions
export const CLEAR_INGREDIENT_LOADING = 'CLEAR_INGREDIENT_LOADING'

// MediaActions
export const CLEAR_ALL_MEDIA = 'CLEAR_ALL_MEDIA'
export const CLEAR_MEDIA_LOADING = 'CLEAR_MEDIA_LOADING'

// MenuActions
export const CLEAR_MENU = 'CLEAR_MENU'
export const CLEAR_MENU_LOADING = 'CLEAR_MENU_LOADING'

// ModifiersActions
export const CLEAR_ALL_MODIFIER = 'CLEAR_ALL_MODIFIER'
export const CLEAR_MODIFIERS_LOADING = 'CLEAR_MODIFIERS_LOADING'

// ModifiersGroupsActions
export const CLEAR_ALL_MODIFIERGROUP = 'CLEAR_ALL_MODIFIERGROUP'
export const CLEAR_MODIFIERS_GROUPS_LOADING = 'CLEAR_MODIFIERS_GROUPS_LOADING'

// OrderActions
export const CLEAR_ORDER_LOADING = 'CLEAR_ORDER_LOADING'

// PlatformActions
export const CLEAR_ALL_PLATFORMS = 'CLEAR_ALL_PLATFORMS'
export const CLEAR_PLATFORM_LOADING = 'CLEAR_PLATFORM_LOADING'

// ProductActions
export const CLEAR_ALL_PRODUCT = 'CLEAR_ALL_PRODUCT'
export const CLEAR_PRODUCTS_LOADING = 'CLEAR_PRODUCTS_LOADING'

// ProfileActions
export const CLEAR_PROFILE_LOADING = 'CLEAR_PROFILE_LOADING'

// PromoCodesActions
export const CLEAR_ALL_PROMOTIONS = 'CLEAR_ALL_PROMOTIONS'
export const CLEAR_PROMO_LOADING = 'CLEAR_PROMO_LOADING'

// RoleActions
export const CLEAR_ROLE_LOADING = 'CLEAR_ROLE_LOADING'

// TaxActions
export const CLEAR_ALL_TAX = 'CLEAR_ALL'
export const CLEAR_TAX_LOADING = 'CLEAR_TAX_LOADING'

// TypesAndAllergiesActions
export const CLEAR_ALL_TYPES_AND_ALLERGIES = 'CLEAR_ALL_TYPES_AND_ALLERGIES'
export const CLEAR_TYPES_LOADING = 'CLEAR_TYPES_LOADING'

// AllergensActions
export const CLEAR_ALLERGENS_LOADING = 'CLEAR_ALLERGENS_LOADING'

// AppUserAddressesActions
export const RESET_APP_USER_ADDRESSES = 'RESET_APP_USER_ADDRESSES'
export const CLEAR_APP_USER_ADDRESSES_LOADING = 'CLEAR_APP_USER_ADDRESSES_LOADING'

// AppUsersGroupsActions
export const CLEAR_APP_USERS_LOADING = 'CLEAR_APP_USERS_LOADING'

// DesignSetupActions
export const CLEAR_DESIGN_LOADING = 'CLEAR_DESIGN_LOADING'

// AffiliateUrlLinkActions
export const CLEAR_URL_LINK_LOADING = 'CLEAR_URL_LINK_LOADING'

// AutomatedMessagesActions
export const CLEAR_AUTO_MSG_LOADING = 'CLEAR_AUTO_MSG_LOADING'

// FloorSetupActions
export const CLEAR_FLOOR_LOADING = 'CLEAR_FLOOR_LOADING'

// LoginDesignSetupActions
export const CLEAR_LOGIN_DESIGN_LOADING = 'CLEAR_LOGIN_DESIGN_LOADING'

// PosLoginDesignSetupActions
export const CLEAR_POS_LOGIN_DESIGN_LOADING = 'CLEAR_POS_LOGIN_DESIGN_LOADING'

// ProductsAvailabilityActions
export const CLEAR_PRODUCTS_AVAILABILITY_LOADING = 'CLEAR_PRODUCTS_AVAILABILITY_LOADING'

// SplashScreenDesignSetupActions
export const CLEAR_SPLASH_SCREEN_LOADING = 'CLEAR_SPLASH_SCREEN_LOADING'

// PaymentsActions
export const CLEAR_PAYMENTS = 'CLEAR_PAYMENTS'

// DirectMessagesActions
export const CLEAR_ALL_DM = 'CLEAR_ALL_DM'
export const CLEAR_LOADING_DM = 'CLEAR_LOADING_DM'
